import React from 'react';

function About() {
  return (
    <div className="container">
      <h1 className="title">
        <a href="/about" style={{ textDecoration: 'none', color: 'inherit' }}>about</a>
      </h1>
      <p>I created this page to share some of my photography along with some random quotes. I wouldn't read too deeply into it. I'm trying to create more of a general atmosphere than a specific message. I made this for myself. Maybe others will like it as well. Maybe not. Such is life.</p>
      <footer style={{ textAlign: 'center', marginTop: '2rem' }}>
        <a href="/" style={{ textDecoration: 'none', color: 'inherit', fontSize: '0.9rem' }}>
          home
        </a>
      </footer>
    </div>
  );
}

export default About; 